import { globalGetService } from '@/utils/globalApiServices';
import { SenderIdInventory } from './types';

export const getCampaignSenderIds = async (
  campaignUid: string,
  data?: unknown,
  configs?: Record<string, unknown>
) => {
  const response = await globalGetService(
    `csp/campaigns/${campaignUid}/senderId`,
    data,
    configs
  );
  return (response?.ok ? response.data : []) as SenderIdInventory[];
};
